import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomTextField from "components/FormFields/CustomTextField";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "./LoadingButton";
import { SignUpPathEnum } from "constants/signUpPath";
import mailImg from "assets/img/mail.png";
import { StyledEmail, StyledFooterBox, StyledTitle } from "./styles";
import { FormContext } from "context/formContext";
import { useEmailVerifyMutation } from "api";

const initialDataModel = {
  email: "",
};

const formSchema = yup.object().shape({
  email: yup
    .string()
    .email("This field is invalid")
    .required("This field is required"),
});

const EmailInfo = () => {
  const { formData, updateFormData } = useContext(FormContext);
  const [verifyEmail] = useEmailVerifyMutation();
  const navigate = useNavigate();
  const location = useLocation();

  const formMethods = useForm({
    mode: "all",
    defaultValues: initialDataModel,
    resolver: yupResolver(formSchema),
  });

  const {
    formState: { isSubmitted },
    reset,
    getValues,
  } = formMethods;

  const handleSubmit = async (data) => {
    try {
      const dataModel = {
        name: formData.name,
        restauratName: formData.restauratName,
        email: data.email,
        addressInfo: formData.addressInfo,
      };
      await verifyEmail(dataModel).unwrap();
      updateFormData(data);
      navigate(SignUpPathEnum.EMAIL_VERIFY);
    } catch (error) {
      console.error(error);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const dataFromStorage = localStorage.getItem("formData");
    const parsedData = JSON.parse(dataFromStorage);
    if (parsedData) {
      const dataModel = {
        email: parsedData.email,
      };
      reset(dataModel);
    } else {
      reset({ email: "" });
    }
  }, [location]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={12} lg={12} sm={12}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
                height: "600px",
              }}
            >
              <Box
                sx={{
                  height: "275px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box sx={{ width: "112px", height: "115px" }}>
                  <StyledEmail src={mailImg} alt={"Send Email"} />
                </Box>
                <Box sx={{ maxWidth: "500px" }}>
                  <StyledTitle sx={{ fontSize: "38px" }}>
                    Verify Your Email
                  </StyledTitle>
                  <Typography sx={{ fontSize: "18px" }}>
                    You’re almost ready to generate your AI Ordering Website!
                    Please enter your email below.
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mt: 4,
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <CustomTextField
                  label=""
                  placeholder={"Provide Email Adress"}
                  name="email"
                  sx={{ minWidth: "300px" }}
                />
              </Box>
              {/* <Divider sx={{ width: "92px", my: 6 }} />
              <Typography
                sx={{
                  maxWidth: "376px",
                  color: "#A2A2A2",
                  fontSize: "12px",
                }}
              >
                Ad temporibus odit est repellendus harum est asperiores omnis ut
                deleniti nostrum ut voluptatem eveniet id doloremque
              </Typography> */}
            </Box>
            <StyledFooterBox sx={{ boxShadow: 4 }}>
              <Grid container m-0 p-0>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
                  <Button variant="outlined" onClick={goBack}>
                    Back
                  </Button>
                  <Button variant="contained" type="submit">
                    Next
                  </Button>
                </Grid>
              </Grid>
            </StyledFooterBox>
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  );
};

export default EmailInfo;
